import { TUI_DIALOGS } from '@taiga-ui/cdk';
import { Provider } from '@angular/core';

import { DrawerService } from './drawer.service';

export const DRAWER_PROVIDER: Provider = {
  provide: TUI_DIALOGS,
  useExisting: DrawerService,
  multi: true,
};
